import PropTypes from 'prop-types';
import React from 'react';

import ReferralConfirmation from './confirmation';
import ReferralError from './error';
import PaypalConfirmation from './paypal-confirmation';
import ReferralPaypalPage from './paypal-page';
import ReferralStripe from './stripe-first';
import ReferralStripeReturn from './stripe-return';
import './payment-page.less';


const ReferralPaymentPage = (props) => {
  const navigateToStripe = () => {
    window.location.replace(`https://connect.stripe.com/express/oauth/authorize?client_id=${props.clientID}&state=${props.path}&redirect_uri=${props.redirectURI}`);
  };

  if (props.payoutRequested || props.status === 'success') {
    if (props.paypal) return <PaypalConfirmation {...props} />;
    return <ReferralConfirmation {...props} />;
  } else if (props.status) {
    return <ReferralError {...props} />;
  } else if (props.paypal) {
    return <ReferralPaypalPage {...props} />;
  } else if (props.stripeID) {
    return <ReferralStripeReturn {...props} navigateToStripe={navigateToStripe} />;
  }

  return <ReferralStripe {...props} navigateToStripe={navigateToStripe} />;
};

ReferralPaymentPage.propTypes = {
  path: PropTypes.string,
  paypal: PropTypes.string,
  redirectURI: PropTypes.string.isRequired,
  payoutRequested: PropTypes.bool,
  stripeID: PropTypes.string,
  clientID: PropTypes.string,
  status: PropTypes.string,
};

ReferralPaymentPage.defaultProps = {
  path: null,
  paypal: null,
  refereeID: null,
  referrerID: null,
  payoutRequested: false,
  stripeID: '',
  clientID: '',
  status: null,
};

export default ReferralPaymentPage;



// WEBPACK FOOTER //
// ./app/components/support/referral/payment-page.jsx